import { render } from "./ShogunFooter.vue?vue&type=template&id=7b83edf2"
import script from "./ShogunFooter.vue?vue&type=script&lang=js"
export * from "./ShogunFooter.vue?vue&type=script&lang=js"

import "./ShogunFooter.vue?vue&type=style&index=0&id=7b83edf2&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__